/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
import { Breadcrumb, Button, Card, Input, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReloadOutlined } from '@ant-design/icons';
import { deleteLocation, getAllLocationPaged } from '../../redux/locationSlice';
import { style } from '../../Styles';
import ActionButton from '../Global/ActionsButton';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import LocationDrawer from './LocationDrawer';

const Location = ({ role }) => {
	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState('locationName');
	const [sortDirection, setSortDirection] = useState('ASC');
	const [isMakingApiCall, setMakingApiCall] = useState(true);
	const [displayDrawer, setDisplayDrawer] = useState(false);
	const [locationId, setLocationId] = useState(null);
	const dispatch = useDispatch();

	const { LocationPaged } = useSelector((state) => state.locations);

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('locationName');
			setSortDirection('ASC');
		}
		setCurrentPage(1);
	};

	const columns = [
		{
			title: 'Location Name',
			dataIndex: 'locationName',
			key: 'locationName',
			sorter: true,
		},
		{
			title: 'Country',
			dataIndex: 'country',
			key: 'country',
			sorter: true,
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<ActionButton
					record={record}
					onDelete={() => handleDeleteLocation(record?.id, () => { })}
					onEdit={() => handleSelectedLocation(record)}
					recordName={record.locationName}
				/>
			),

			disabled: !role?.includes('SUPER_ADMIN'),
		},
	];

	const handleDeleteLocation = (id, callback) => {
		setMakingApiCall(true);
		dispatch(
			deleteLocation({
				locationId: id,
			}),
		)
			.unwrap()
			.then(() => {
				callback();
				message.success('Location deleted successfully');
			})
			.catch(() => { })
			.finally(() => {
				onCloseDrawer();
				setMakingApiCall(false);
			});
	};

	const handleSelectedLocation = (selectedLocation) => {
		setLocationId(selectedLocation.id);
		showDrawer();
	};

	const onCloseDrawer = () => {
		setDisplayDrawer(false);
		setLocationId(null);
	};

	const showDrawer = () => {
		setDisplayDrawer(true);
	};

	const fetchAll = () => {
		setMakingApiCall(true);
		dispatch(getAllLocationPaged({ page: currentPage - 1, size: pageSize, sortBy, sortDirection, search }))
			.unwrap()
			.then()
			.catch(() => {
				message.error('Error fetching locations');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	useEffect(() => {
		fetchAll();
	}, [dispatch, currentPage, pageSize, sortBy, sortDirection, search]);

	const locationArray = LocationPaged.list.map((item) => ({ ...item, key: item.id }));

	return (
		<>
			<Card style={{
				margin: 16,
				maxHeight: '90%', // Set maximum width
				height: 'auto', // Allow width to be dynamic
			}}>
				<div style={style.inlineContent}>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'left',
							marginBottom: 8,
						}}>
						<Breadcrumb
							style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
							items={[
								{
									title: 'Locations',
								},
								{
									title: 'Geofence Locations',
								},
							]}
						/>
						<Button
							type='default'
							size='small'
							// style={{ margin: '0 8px 8px 0' }}
							onClick={() => fetchAll()}>
							<ReloadOutlined />
						</Button>
					</div>

					<div
						style={{
							...style.inlineContent,
							float: 'right',
							marginBottom: 8,
						}}>
						<Input.Search
							placeholder='Search'
							style={{ margin: '0 8px 8px 0' }}
							onSearch={(val) => {
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								setCurrentPage(1);
								setSearch(val);
							}}
							onChange={(e) => {
								const val = e.target.value;
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								searchTimerRef.current = setTimeout(() => {
									setCurrentPage(1);
									setSearch(val);
								}, 400);
							}}
						/>
						{role?.includes('SUPER_ADMIN') && (
							<Button
								type='default'
								style={{ float: 'right', marginBottom: 8 }}
								onClick={showDrawer}>
								Add Geofence Location
							</Button>
						)}
					</div>
				</div>
				<CustomTableComponentsPageable
					isMakingApiCall={isMakingApiCall}
					columns={columns.filter((item) => {
						return item.disabled !== true;
					})}
					dataArray={locationArray}
					handleSelectedRow={() => { }}
					handleDoubleClickRow={(record) =>
						role?.includes('SUPER_ADMIN') ? handleSelectedLocation(record) : {}
					}
					emptyText="No matching locations"
					onTableChange={handleTableChange}
					pagination={{
						current: currentPage,
						pageSize,
						total: LocationPaged.total || 0,
						onChange: (page, size) => {
							setCurrentPage(page);
							setPageSize(size);
						},
					}}
				/>
			</Card>
			{displayDrawer && (
				<LocationDrawer
					onClose={onCloseDrawer}
					locationId={locationId}
					handleDeleteLocation={handleDeleteLocation}
				/>
			)}
		</>
	);
};

export default Location;
